export default "__VITE_ASSET__Dz72lMFO__"